import { Column } from "@/components/Column";

// Stands on the ridge between the pond and the back row, behind the pets.
export const PlayyardScarecrow = () => {
  return (
    <Column className="pointer-events-none absolute left-[33%] top-[61%] z-[8] h-[17%] w-[5cqw] -translate-x-1/2 -translate-y-full">
      <Column className="absolute bottom-0 left-1/2 h-full w-[8%] -translate-x-1/2 bg-[#6b4a2c]" />
      <Column className="absolute left-0 top-[40%] h-[5%] w-full rounded-full bg-[#6b4a2c]" />
      <Column className="absolute left-[22%] top-[34%] h-[38%] w-[56%] rounded-[30%_30%_20%_20%] bg-[repeating-linear-gradient(90deg,#7c3f2a_0_4px,#94512f_4px_8px)]" />
      <Column className="absolute left-[-6%] top-[38%] h-[10%] w-[18%] rounded-full bg-[#d9b25c]" />
      <Column className="absolute right-[-6%] top-[38%] h-[10%] w-[18%] rounded-full bg-[#d9b25c]" />
      <Column className="absolute left-[28%] top-[14%] h-[22%] w-[44%] rounded-full bg-[#e7c98d]">
        <Column className="absolute left-[24%] top-[38%] h-[18%] w-[16%] rotate-45 bg-[#2a1d16]" />
        <Column className="absolute right-[24%] top-[38%] h-[18%] w-[16%] rotate-45 bg-[#2a1d16]" />
        <Column className="absolute bottom-[20%] left-[30%] h-[8%] w-[40%] bg-[repeating-linear-gradient(90deg,#2a1d16_0_2px,transparent_2px_4px)]" />
      </Column>
      <Column className="absolute left-[30%] top-[5%] h-[12%] w-[40%] rounded-t-[50%] bg-[#c9a24e]" />
      <Column className="absolute left-[20%] top-[15%] h-[4%] w-[60%] rounded-full bg-[#b38b3c]" />
    </Column>
  );
};
